import React from 'react';
import PropTypes from 'prop-types';

import { isNil } from 'lodash';
import moment from 'moment';

import {
    ContentZonesService,
    LocaleService,
    WindowProxy,
    ConfigsService,
    UrlService,
} from '@sm360/widget-commons-core-services';
import {
    REDIRECTIONS,
    CONSTANT,
    UtilsService as CommonUtilsService,
    EVENTS as EVENTS_COMMONS_GENERAL,
    AdobeService,
    ADOBE_TAGS,
    AnalyticsService,
    VIRTUAL_PAGEVIEWS as PAGES,
    PriceAmounts,
} from '@sm360/widget-commons-general';
import { Vehicle, CurrencyFormats, ORGANIZATIONS } from '@sm360/widget-commons-vehicle';

import ConditionReport from '@sm360/condition-report';
// TODO: Put this back with official trade-in into CRM import { CurrencyFormats } from 'commons-vehicle';

import GarageContainer from 'login/components/Transaction/TransactionActionDetails/GarageContainer.jsx';
import TransactionActionDetails from 'login/components/Transaction/TransactionActionDetails/TransactionActionDetails.jsx';
import FinancingState from 'login/components/Transaction/TransactionAction/TransactionFinancingState/TransactionFinancingState.jsx';

import TAGS from 'login/constants/trackingTags';

import 'login/components/Transaction/TransactionAction/TransactionActionTrade360.scss';

const { QuestionsListHelpers, Models } = ConditionReport;
const czGroup = 'widget.transaction';
const tradeInBarSlug = 'tradein';
class TransactionAction extends React.Component {
    constructor(props) {
        super(props);
        this.onTradeInClick = this.onTradeInClick.bind(this);
        this.actionHandleClick = this.actionHandleClick.bind(this);
        this.renderGarageSection = this.renderGarageSection.bind(this);
        this.renderTradeInSection = this.renderTradeInSection.bind(this);
        this.renderFinanceSection = this.renderFinanceSection.bind(this);
        this.renderReservationSection = this.renderReservationSection.bind(this);
        this.renderPreferredAppointmentText = this.renderPreferredAppointmentText.bind(this);
        this.onAppointmentRequestClick = this.onAppointmentRequestClick.bind(this);
        this.displayAppointmentFormLink = this.displayAppointmentFormLink.bind(this);
        this.onDeleteTradeIn = this.onDeleteTradeIn.bind(this);
        this.onViewTradeIn = this.onViewTradeIn.bind(this);

        const organizationId = ConfigsService.getOrganizationId();

        const isDilawriVersion =
            parseInt(UrlService.getUrlParameter('version'), 10) === 2 || organizationId === ORGANIZATIONS.DILAWRI;

        this.state = {
            displayTrade360: !isDilawriVersion,
        };
    }

    componentDidMount() {
        const $window = WindowProxy.get();
        if ($window) {
            $window.document.addEventListener(EVENTS_COMMONS_GENERAL.SWITCH_TO_TRADEIN_BAR, () =>
                this.actionHandleClick(tradeInBarSlug)
            );
        }
    }

    componentWillUnmount() {
        const $window = WindowProxy.get();

        if ($window) {
            $window.document.removeEventListener(EVENTS_COMMONS_GENERAL.SWITCH_TO_TRADEIN_BAR, () =>
                this.actionHandleClick(tradeInBarSlug)
            );
        }
    }

    onTradeInClick(isOfficial, loadExistingTradeIn, editOfficial) {
        AnalyticsService.ga4Trigger(TAGS.MY_TRANSACTION__OFFICIAL_EVALUATION_BTN());
        const windowProxy = WindowProxy.get();
        const locale = LocaleService.getSimpleLocale();
        if (windowProxy) {
            if (isOfficial) {
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(
                        ADOBE_TAGS.TRANSACTION_BAR_CTA(
                            CONSTANT.TRANSACTION.TRADEIN.TITLE,
                            CONSTANT.TRANSACTION.TRADEIN.OFFICIAL
                        ),
                        'global-onclick'
                    );
                }
                const existingTradeInRedirection = editOfficial
                    ? REDIRECTIONS[locale].editExistingTradeInOfficial
                    : REDIRECTIONS[locale].existingTradeInOfficial;

                windowProxy.location.href = loadExistingTradeIn
                    ? existingTradeInRedirection
                    : REDIRECTIONS[locale].newTradeInOfficial;
            } else {
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(
                        ADOBE_TAGS.TRANSACTION_BAR_CTA(
                            CONSTANT.TRANSACTION.TRADEIN.TITLE,
                            CONSTANT.TRANSACTION.TRADEIN.INSTANT
                        ),
                        'global-onclick'
                    );
                }
                AnalyticsService.ga4Trigger(TAGS.MY_TRANSACTION__INSTANT_TRADE());
                windowProxy.location.href = this.state.displayTrade360
                    ? REDIRECTIONS[locale].tradeIn
                    : REDIRECTIONS[locale].tradeInEstimatedDilawri;
            }
        }
    }

    onAppointmentRequestClick() {
        const windowProxy = WindowProxy.get();
        const locale = LocaleService.getSimpleLocale();
        if (windowProxy) {
            windowProxy.location.href = REDIRECTIONS[locale].tradeInAppointment;
        }
    }

    onViewTradeIn() {
        AnalyticsService.ga4Trigger(TAGS.MY_TRANSACTION__TRADE_IN_VIEW_VEHICLE());
        window.location = REDIRECTIONS[LocaleService.getSimpleLocale()].tradeInView;
    }

    onDeleteTradeIn() {
        AnalyticsService.ga4Trigger(TAGS.MY_TRANSACTION__TRADE_IN_DELETE_VEHICLE());
        this.props.deleteTradeIn();
    }

    actionHandleClick(itemSlug) {
        if (itemSlug === tradeInBarSlug) {
            AnalyticsService.virtualPageView(PAGES.MY_TRADEIN_HEADER());
        }
        if (this.props.isAuthenticated) {
            this.props.onActionOpen(itemSlug);
        } else {
            this.props.loginClick(() => this.actionHandleClick(itemSlug));
        }
    }

    displayAppointmentFormLink(appointmentDate) {
        return (
            <>
                {LocaleService.t(
                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.PREFERRED_EXPIRED_APPOINTMENT_TEXT',
                    {
                        appointmentDate,
                    }
                )}
                <a
                    className="sr-appointment-request-text sr-text expired-appointment-text"
                    href={REDIRECTIONS[LocaleService.getSimpleLocale()].tradeInAppointment}
                >
                    <span>
                        {LocaleService.t(
                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.REQUEST_ANOTHER_APPOINTMENT'
                        )}
                    </span>
                </a>
            </>
        );
    }

    renderGarageSection() {
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails>
                    <GarageContainer
                        isOpen={this.props.stateActionsOpen.garage}
                        isNewEnabled={this.props.isNewEnabled}
                        isUsedEnabled={this.props.isUsedEnabled}
                        usedUrl={this.props.usedUrl}
                        timeSaved={this.props.timeSaved}
                        tradeInAmount={this.props.tradeInAmount}
                        tradeInTaxCredits={this.props.tradeInTaxCredits}
                        dataTest="login.transaction.garage.details"
                        isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                </TransactionActionDetails>
            )
        );
    }

    renderPreferredAppointmentText() {
        const shouldDisplayPreferredAppointmentText =
            this.state.displayTrade360 &&
            moment(this.props.vehicleTradein?.appointmentDate, CONSTANT.APPOINTMENT_DATE_FORMAT, true).isValid();

        if (shouldDisplayPreferredAppointmentText) {
            const appointmentDate = moment(this.props.vehicleTradein.appointmentDate)
                .locale(LocaleService.getSimpleLocale())
                .format('ddd, ll');

            const isAppointmentDateValid = moment(this.props.vehicleTradein.appointmentDate).isSameOrAfter(
                new Date(),
                'day'
            );

            return (
                <p className={`sr-appointment-text sr-text ${!isAppointmentDateValid && 'expired-appointment-text'}`}>
                    {isAppointmentDateValid
                        ? LocaleService.t(
                              'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.PREFERRED_APPOINTMENT_TEXT',
                              {
                                  appointmentDate,
                              }
                          )
                        : this.displayAppointmentFormLink(appointmentDate)}
                </p>
            );
        }
        return false;
    }

    renderTradeInSection() {
        const { vehicleTradein } = this.props;
        const { displayTrade360 } = this.state;

        const cz = ContentZonesService.getContentZone(czGroup, 'bar.tradein.hascbb');
        const hasVehicleEvaluationValue = cz && cz.getValue();
        const hasCBB = hasVehicleEvaluationValue === 'true';
        const dataTestTradeIn = 'login.transaction.tradein.details';

        const { conditionForm, officialAmount, officialAmountExp } = vehicleTradein;

        const isOfficialAmountExpired = !!officialAmountExp && new Date(officialAmountExp) <= new Date();
        const isOfficialAmountValid = officialAmount > 0 && !isOfficialAmountExpired;

        const conditionFormProgressStatus = QuestionsListHelpers.getQuestionnaireProgressStatus(
            conditionForm,
            Models.DeskingQuestionsModel
        );
        // Display appointment button only for non-dilawri dealers (for now) & if appointment date is not available
        const shouldDisplayAppointmentBtn = displayTrade360 && !vehicleTradein?.appointmentDate;
        const shouldDisplayOfficialBtn = officialAmount === 0;
        // Display official evaluation submitted notification if evaluation started or completed without dealer appreciation value
        const shouldDisplayOfficialSubmitText =
            officialAmount === 0 &&
            [CONSTANT.OFFICIAL_FORM_STATUS.NOT_COMPLETED, CONSTANT.OFFICIAL_FORM_STATUS.ALL_COMPLETED].includes(
                conditionFormProgressStatus
            );

        let vehicleAmountLabel = LocaleService.t(
            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE_AMOUNT_NA'
        );
        if (!isNil(vehicleTradein.amount) && vehicleTradein.amount > 0) {
            vehicleAmountLabel = (
                <PriceAmounts price={LocaleService.l(vehicleTradein.amount, CurrencyFormats.CURRENCY_0)} />
            );
        }

        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails timeSaved={this.props.timeSaved}>
                    {this.props.isCompleted ? (
                        <div data-test={dataTestTradeIn}>
                            <h3 className="sr-text is-bold">
                                {LocaleService.t(
                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.TITLE'
                                )}
                            </h3>
                            <br />
                            {hasCBB &&
                                !isNil(vehicleTradein.amount) && (
                                    <p className="sr-text">
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE_AMOUNT_TEXT'
                                        )}{' '}
                                        {vehicleAmountLabel}
                                    </p>
                                )}
                            <p className="sr-text">
                                {!isNil(vehicleTradein.make) &&
                                    !isNil(vehicleTradein.model) &&
                                    !isNil(vehicleTradein.year) &&
                                    !isNil(vehicleTradein.modelTrim) &&
                                    LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.VEHICLE',
                                        {
                                            make: vehicleTradein.make,
                                            model: vehicleTradein.model,
                                            year: vehicleTradein.year,
                                            modelTrim: vehicleTradein.modelTrim,
                                        }
                                    )}
                                {!isNil(vehicleTradein.odometer) &&
                                    LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.ODOMETER',
                                        {
                                            odometer: vehicleTradein.odometer,
                                        }
                                    )}
                            </p>
                            {!isNil(vehicleTradein.make) &&
                                !isNil(vehicleTradein.model) &&
                                !isNil(vehicleTradein.year) &&
                                !isNil(vehicleTradein.modelTrim) && (
                                    <>
                                        <div className="trade-in-actions">
                                            {// Hide the view trade-in button for selected organization Id
                                            displayTrade360 && (
                                                <a className="sr-link view-trade-in" onClick={this.onViewTradeIn}>
                                                    <icon className="icon-eye" />
                                                    <span>{LocaleService.t('LOGIN.VIEW')}</span>
                                                </a>
                                            )}
                                            {(!displayTrade360 || !isOfficialAmountValid) && (
                                                <a className="sr-link delete-trade-in" onClick={this.onDeleteTradeIn}>
                                                    <icon className="icon-trash-can" />
                                                    <span>{LocaleService.t('LOGIN.DELETE')}</span>
                                                </a>
                                            )}
                                        </div>
                                        <div>
                                            {shouldDisplayAppointmentBtn && (
                                                <button
                                                    className="sr-button-1 cta-btn"
                                                    onClick={this.onAppointmentRequestClick}
                                                    data-test="login.transaction.tradein.official-evaluation-redirection"
                                                >
                                                    {LocaleService.t(
                                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.REQUEST_AN_APPOINTMENT_TEXT'
                                                    )}
                                                </button>
                                            )}
                                            {this.renderPreferredAppointmentText()}
                                        </div>
                                        {hasCBB && (
                                            <p className="sr-disclaimer">
                                                {LocaleService.t(
                                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.ESTIMATED_LEGAL_DISCLAIMER'
                                                )}
                                            </p>
                                        )}
                                    </>
                                )}
                            <br />
                            {// Hide the official trade-in evaluation button and text for selected Organization Id
                            displayTrade360 && (
                                <>
                                    <hr />
                                    <div className="sr-text is-bold">
                                        {/* TODO: Put this back after official trade-in work in CRM
                                            LocaleService.t(
                                                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.ESTIMATED_VALUE')}
                                            {
                                                    vehicleTradein.retail > 0 ? (
                                                        <span className="is-price">
                                                            {LocaleService.l(vehicleTradein.retail, CurrencyFormats.CURRENCY_0)}
                                                        </span>
                                                    ) : (
                                                        LocaleService.t('LOGIN.PENDING')
                                                    )
                                                */}
                                        {officialAmount > 0
                                            ? LocaleService.t(
                                                  'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_OFFICIAL.APPRAISED_TITLE'
                                              )
                                            : LocaleService.t(
                                                  'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_OFFICIAL.QUESTION_TITLE'
                                              )}
                                    </div>
                                    {/* TODO: Put this back after official trade-in work in CRM
                                        <br />
                                        <div className="sr-disclaimer">
                                            <icon className="icon-Warning is-warning" />
                                            &nbsp;{LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_NON_OFFICIAL.WARNING')}
                                        </div> */}
                                    {officialAmount > 0 ? (
                                        <Vehicle.TradeInOfficialValue
                                            amount={officialAmount}
                                            expiration={officialAmountExp}
                                            onTradeInClick={() => this.onTradeInClick(true, true, true)}
                                        />
                                    ) : (
                                        <>
                                            {shouldDisplayOfficialSubmitText && (
                                                <p className="sr-text official-submission-notification">
                                                    {conditionFormProgressStatus ===
                                                    CONSTANT.OFFICIAL_FORM_STATUS.NOT_COMPLETED
                                                        ? LocaleService.t(
                                                              'TRANSACTION_PROGRESSION.PARTIAL_COMPLETED_OFFICIAL_EVALUATION_SUBMITTED'
                                                          )
                                                        : LocaleService.t(
                                                              'TRANSACTION_PROGRESSION.COMPLETE_OFFICIAL_EVALUATION_SUBMITTED'
                                                          )}
                                                </p>
                                            )}
                                            <div>
                                                {shouldDisplayOfficialBtn && (
                                                    <button
                                                        className="sr-button-1 cta-btn"
                                                        onClick={() => this.onTradeInClick(true, true)}
                                                        data-test="login.transaction.tradein.official-evaluation-redirection"
                                                    >
                                                        {CommonUtilsService.getOfficialEvaluationLabel(
                                                            conditionFormProgressStatus
                                                        )}
                                                    </button>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    <p className="sr-disclaimer">
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.LEGAL_WARNING'
                                        )}
                                    </p>
                                </>
                            )}
                        </div>
                    ) : (
                        <div data-test={dataTestTradeIn}>
                            <h3 className="sr-text is-bold">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.TITLE')}
                            </h3>
                            <p className="sr-text">
                                {LocaleService.t(
                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.SUBTITLE'
                                )}
                            </p>
                            <br />
                            <ul className="earnings_listing">
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_1'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_2'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.ADVANTAGE_3'
                                    )}
                                </li>
                            </ul>
                            <br />
                            {hasCBB && (
                                <button
                                    className="sr-button-1"
                                    onClick={() => this.onTradeInClick(false)}
                                    data-test="login.transaction.tradein.create-redirection"
                                >
                                    {LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.BUTTON_LABEL_CBB'
                                    )}
                                </button>
                            )}
                            {// Hide the official trade-in evaluation button and text for selected Organization Id
                            displayTrade360 && (
                                <>
                                    <button
                                        className="sr-button-outline-1"
                                        onClick={() => this.onTradeInClick(true)}
                                        data-test="login.transaction.tradein.official-evaluation-redirection"
                                    >
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.NOT_DONE.TAKE_ACTION'
                                        )}
                                    </button>
                                    <p className="sr-disclaimer">
                                        {LocaleService.t(
                                            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.LEGAL_WARNING'
                                        )}
                                    </p>
                                </>
                            )}
                        </div>
                    )}
                </TransactionActionDetails>
            )
        );
    }

    renderFinanceSection() {
        const financeButtonLabel = LocaleService.t(
            'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.BUTTON_LABEL_APPLY'
        );

        const handleClick = () => {
            if (this.props.hasAdobeTagging) {
                AdobeService.eventTrigger(
                    ADOBE_TAGS.TRANSACTION_BAR_CTA(
                        CONSTANT.TRANSACTION.FINANCE.TITLE,
                        CONSTANT.TRANSACTION.FINANCE.APPLY_NOW
                    ),
                    'global-onclick'
                );
            }
        };

        const financeButton = (
            <a
                className="sr-button-outline-1"
                title={financeButtonLabel}
                href={REDIRECTIONS[LocaleService.getSimpleLocale()].financing}
                onClick={handleClick}
            >
                {financeButtonLabel}
            </a>
        );
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails timeSaved={this.props.timeSaved}>
                    {this.props.isCompleted ? (
                        <div data-test="login.transaction.finance.details">
                            <FinancingState />
                        </div>
                    ) : (
                        <div data-test="login.transaction.finance.details">
                            <h3 className="sr-text is-bold">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.TITLE')}
                            </h3>
                            <p className="sr-text">
                                {LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.SUBTITLE')}
                            </p>
                            <br />
                            <ul className="earnings_listing">
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    &nbsp;{LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ADVANTAGE_1'
                                    )}
                                </li>
                                <li>
                                    <icon className="icon-Crochet sr-sucessColor" />
                                    &nbsp;{LocaleService.t(
                                        'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.FINANCE.ADVANTAGE_2'
                                    )}
                                </li>
                            </ul>
                            <br />
                            {financeButton}
                        </div>
                    )}
                </TransactionActionDetails>
            )
        );
    }

    renderReservationSection() {
        return (
            this.props.isAuthenticated && (
                <TransactionActionDetails>
                    <GarageContainer
                        isOpen={this.props.stateActionsOpen.garage}
                        isNewEnabled={this.props.isNewEnabled}
                        isUsedEnabled={this.props.isUsedEnabled}
                        usedUrl={this.props.usedUrl}
                        timeSaved={this.props.timeSaved}
                        tradeInAmount={this.props.tradeInAmount}
                        tradeInTaxCredits={this.props.tradeInTaxCredits}
                        dataTest="login.transaction.reservation.details"
                        isReservationMode
                        isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                </TransactionActionDetails>
            )
        );
    }

    render() {
        const { itemSlug } = this.props;

        const icon = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.icon`).getValue();
        const label = ContentZonesService.getContentZone('widget.transaction', `${itemSlug}.label`).getValue();

        const actionDetailsRender = {};
        actionDetailsRender.garage = this.renderGarageSection();
        actionDetailsRender.tradein = this.renderTradeInSection();
        actionDetailsRender.finance = this.renderFinanceSection();
        actionDetailsRender.reserve = this.renderReservationSection();

        const isActionValidate = this.props.isCompleted;
        const isActionWarning = false;
        const classNames = ['TransactionAction--single'];

        if (this.props.isCompleted) {
            classNames.push('is-validate');
        }

        if (this.props.stateActionsOpen[itemSlug]) {
            classNames.push('is-active');
        }
        return (
            <div className={classNames.join(' ')}>
                <button
                    onClick={() => this.actionHandleClick(itemSlug)}
                    data-test={`login.transaction.${itemSlug}.open`}
                >
                    {itemSlug === 'garage' &&
                        this.props.isAuthenticated && (
                            <div className="TransactionAction--single__amount sr-button-1 is-small">
                                {this.props.garageCount}
                            </div>
                        )}
                    <img src={icon} alt={`${label.replaceAll(' ', '-').toLowerCase()}-img`} />
                    <div className="label">
                        {isActionValidate && <icon className="icon-Crochet sr-sucessColor" />}
                        {isActionWarning && <icon className="icon-Warning is-warning" />}
                        {label}
                    </div>
                </button>
                <div
                    className={`TransactionAction--details ${
                        this.props.stateActionsOpen[itemSlug] ? 'is-visible' : ''
                    }`}
                >
                    {actionDetailsRender[itemSlug]}
                </div>
            </div>
        );
    }
}

TransactionAction.propTypes = {
    itemSlug: PropTypes.string.isRequired,
    garageCount: PropTypes.number.isRequired,
    isCompleted: PropTypes.bool,
    stateActionsOpen: PropTypes.shape({
        garage: PropTypes.bool.isRequired,
        tradein: PropTypes.bool.isRequired,
        finance: PropTypes.bool.isRequired,
    }).isRequired,
    onActionOpen: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    tradeInTaxCredits: PropTypes.number.isRequired,
    timeSaved: PropTypes.number,
    vehicleTradein: PropTypes.shape({
        tradeId: PropTypes.string.isRequired,
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        modelTrim: PropTypes.string.isRequired,
        year: PropTypes.number.isRequired,
        odometer: PropTypes.number.isRequired,
        retail: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
        officialAmount: PropTypes.number.isRequired,
        officialAmountExp: PropTypes.number.isRequired,
        appointmentDate: PropTypes.string.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    loginClick: PropTypes.func.isRequired,
    deleteTradeIn: PropTypes.func.isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
};

TransactionAction.defaultProps = {
    timeSaved: 0,
    isCompleted: false,
    isMultiDealerGarage: false,
    hasAdobeTagging: false,
};

TransactionAction.displayName = 'TransactionAction';

export default TransactionAction;
